// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDetails} from '../../shared/repositories';

export const readPipDetails = pipId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDetails(pipId);

            dispatch({
                data,
                type: actions.READ_PIP_DETAILS_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetPipDetails = () => ({
    type: actions.RESET_PIP_DETAILS
});



// WEBPACK FOOTER //
// ./src/pip/pip-details/action-creators/pip-details.js